import Vue from "vue";
import Router from "vue-router";
import store from "@/core/services/store";
import { VERIFY_AUTH } from "@/core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    // --------------------------------------
    // Gestion publique
    // --------------------------------------
    {
      name: "home",
      path: "/",
      component: () => import("@/view/pages/auth/Login")
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/view/pages/auth/Login")
    },
    {
      name: "logout",
      path: "/logout",
      component: () => import("@/view/pages/auth/Logout")
    },
    {
      name: "loginCallback",
      path: "/login/callback",
      component: () => import("@/view/pages/auth/LoginCallback")
    },
    {
      name: "register",
      path: "/register",
      component: () => import("@/view/pages/auth/Register")
    },
    {
      name: "resetPassword",
      path: "/reset-password",
      component: () => import("@/view/pages/auth/Login")
    },
    // --------------------------------------
    // Routes applications
    // --------------------------------------
    {
      path: "/app",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/tableau-de-bord",
          name: "tableauDeBord",
          component: () => import("@/view/pages/Dashboard.vue"),
        },
        {
          path: "/user-admin/poster-video",
          name: "posterVideoUser",
          component: () => import("@/view/pages/video/postVideoUser.vue"),
        },
        {
          path: "/bibliotheque-videos",
          name: "bibliothequeVideos",
          component: () => import("@/view/pages/video/listVideos.vue"),
        },
        {
          path: "/video/:id",
          name: "video",
          component: () => import("@/view/pages/video/contentVideo.vue"),
        },
        {
          path: "/bibliotheque-parcours",
          name: "bibliothequeParcours",
          component: () => import("@/view/pages/course/listCourses.vue"),
        },
        {
          path: "/video/:id/parcours/:idParcours",
          name: "videoFromCourse",
          component: () => import("@/view/pages/course/contentVideo.vue"),
        },
        {
          path: "/bibliotheque-themes",
          name: "bibliothequeThemes",
          component: () => import("@/view/pages/theme/userContentRead.vue"),
        },
        {
          path: "/video/:id/theme/:idTheme",
          name: "videoFromTheme",
          component: () => import("@/view/pages/theme/contentVideo.vue"),
        },
        {
          path: "/quotaReached",
          name: "freemiumQuotaReached",
          component: () => import("@/view/pages/error/freemiumQuotaReached.vue"),
        },
        // --------------------------------------
        // Cockpit
        // --------------------------------------
        {
          path: "gestion-cockpit",
          name: "gestionCockpit",
          component: () => import("@/view/pages/superUser/cockpit.vue"),
        },

      ],
    },
    // --------------------------------------
    // Routes d'administrations
    // --------------------------------------
    {
      path: "/admin",
      component: () => import("@/view/layout/Layout"),
      children: [
        // --------------------------------------
        // KPI 
        // --------------------------------------
        {
          path: "admin-kpi",
          name: "adminKPI",
          component: () => import("@/view/pages/admin/kpi.vue"),
        },
        // --------------------------------------
        // Gestion des comptes Bosco
        // --------------------------------------
        {
          path: "gestion-compte-bosco",
          name: "gestionCompteBosco",
          component: () => import("@/view/pages/admin/boscoManagement.vue"),
        },
        {
          path: "creer-utilisateur-bosco",
          name: "creerUtilisateurBosco",
          component: () => import("@/view/pages/admin/user/addUserBosco.vue"),
        },
        {
          path: "modifier-utilisateur-bosco",
          name: "modifierUtilisateurBosco",
          component: () => import("@/view/pages/admin/user/editUserBosco.vue"),
        },
        // --------------------------------------
        // Gestion des contenus
        // --------------------------------------
        {
          path: "gestion-contenus",
          name: "gestionContenus",
          component: () => import("@/view/pages/admin/contentManagement.vue"),
        },
        // Parcours
        {
          path: "creer-parcours",
          name: "creerParcours",
          component: () => import("@/view/pages/admin/course/addCourse.vue"),
        },
        {
          path: "modifier-parcours/:id",
          name: "modifierParcours",
          component: () => import("@/view/pages/admin/course/editCourse.vue"),
        },
        // Vidéos
        {
          path: "creer-video",
          name: "creerVideo",
          component: () => import("@/view/pages/admin/video/addVideo.vue"),
        },
        {
          path: "modifier-video/:id",
          name: "modifierVideo",
          component: () => import("@/view/pages/admin/video/editVideo.vue"),
        },
        // --------------------------------------
        // Gestion des clients
        // --------------------------------------
        {
          path: "gestion-clients",
          name: "gestionClients",
          component: () => import("@/view/pages/admin/clientManagement.vue"),
        },
        // Clients
        {
          path: "creer-client",
          name: "creerClient",
          component: () => import("@/view/pages/admin/client/addClient.vue"),
        },
        {
          path: "modifier-client/:id",
          name: "modifierClient",
          component: () => import("@/view/pages/admin/client/editClient.vue"),
        },
        {
          path: "gestion-contenu-client",
          name: "gestionContenuClients",
          component: () => import("@/view/pages/admin/client/contentClient.vue"),
        },
        // Droits utilisateurs
        {
          path: "creer-droit-utilisateur",
          name: "creerDroitUtilisateur",
          component: () => import("@/view/pages/admin/userRight/addUserRight.vue"),
        },
        {
          path: "modifier-droit-utilisateur/:id",
          name: "modifierDroitUtilisateur",
          component: () => import("@/view/pages/admin/userRight/editUserRight.vue"),
        },
        {
          path: "modifier-plusieurs-droit-utilisateur/:ids",
          name: "modifierPlusieursDroitUtilisateur",
          component: () => import("@/view/pages/admin/userRight/editMultipleUserRight.vue"),
        },
        // Utilisateurs
        {
          path: "creer-utilisateur",
          name: "creerUtilisateur",
          component: () => import("@/view/pages/admin/user/addUser.vue"),
        },
        {
          path: "modifier-utilisateur/:id",
          name: "modifierUtilisateur",
          component: () => import("@/view/pages/admin/user/editUser.vue"),
        },
         // --------------------------------------
        // Gestion des partenaires
        // --------------------------------------
        {
          path: "gestion-partenaires",
          name: "gestionPartenaires",
          component: () => import("@/view/pages/admin/partnerManagement.vue"),
        },
        {
          path: "creer-partenaire",
          name: "creerPartenaire",
          component: () => import("@/view/pages/admin/partner/addPartner.vue"),
        },
        {
          path: "modifier-partenaire/:id",
          name: "modifierPartenaire",
          component: () => import("@/view/pages/admin/partner/editPartner.vue"),
        },
        // --------------------------------------
        // Gestion des notifications
        // --------------------------------------
        {
          path: "gestion-notifications",
          name: "gestionNotfications",
          component: () => import("@/view/pages/admin/notificationManagement.vue"),
        },
      ],
    },
    // --------------------------------------
    // Autres routes
    // --------------------------------------
    {
      path: "*",
      redirect: "/404",
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/Error-6.vue"),
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(() => {
    const {isAuthenticated, isSuperUser, isAdmin} = store.getters;
    const notSecuredRouteNames = ['home', 'login', 'loginCallback', 'register', 'resetPassword'];
    const videoRouteNames = ['videoFromTheme', 'videoFromCourse', 'video'];
    if (!notSecuredRouteNames.includes(to.name) && !isAuthenticated) {
      next({ name: 'login' });
    } else if (to.path.startsWith('/user-admin') && !isSuperUser){
      next({ name: 'tableauDeBord' });
    } else if (to.path.startsWith('/admin') && !isAdmin) {
      next({ name: 'tableauDeBord' });
    } else if (videoRouteNames.includes(to.name) && store.getters.isFreemium && !store.getters.isFreemiumAuthorized) {
      next({ name: 'freemiumQuotaReached' });
    }
    else {
      next();
    }
    
    // reset config to initial state
    store.dispatch(RESET_LAYOUT_CONFIG);

    // Scroll page to top on every route change
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  });
});

export default router;
